import React, { useEffect, useState } from 'react';
import { Card, ListGroup, Badge, Spinner } from 'react-bootstrap';
import { getExpiringEmployees } from '../services/api';
import { Link } from 'react-router-dom';
import moment from 'moment';

const ExpiringEmployees = () => {
  const [expiringEmployees, setExpiringEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchExpiringEmployees = async () => {
      try {
        setLoading(true);
        const response = await getExpiringEmployees(15);
        setExpiringEmployees(response.data);
      } catch (err) {
        console.error('Error fetching expiring employees:', err);
        setError('Failed to load expiring employees');
      } finally {
        setLoading(false);
      }
    };

    fetchExpiringEmployees();
  }, []);

  if (loading) {
    return (
      <div className="text-center p-3">
        <Spinner animation="border" size="sm" />
        <span className="ms-2">Loading expiring employees...</span>
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  if (expiringEmployees.length === 0) {
    return <div className="text-muted p-3">No employees with expiring contracts in the next 15 days.</div>;
  }

  return (
    <ListGroup variant="flush">
      {expiringEmployees.map((employee) => (
        <ListGroup.Item key={employee.id} className="d-flex justify-content-between align-items-center">
          <div>
            <Link to={`/employees/${employee.id}`} className="text-decoration-none">
              {employee.name}
            </Link>
            <div className="text-muted small">
              {employee.employee_type} • Expires {moment(employee.expiry_date).format('MMM D, YYYY')}
            </div>
          </div>
          <Badge bg={employee.days_until_expiry <= 7 ? 'danger' : 'warning'}>
            {Math.floor(employee.days_until_expiry)} {Math.floor(employee.days_until_expiry) === 1 ? 'day' : 'days'} left
          </Badge>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

export default ExpiringEmployees;
